import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { useBackgroundImage } from 'client/hooks/useBackgroundImage'
import React from 'react'
import { CommonWebsiteHeader } from 'src/shared/entities/website-header'
import { WebsiteHeaderInterface } from 'src/shared/types/website-entities'
import { useThemeColor } from '../../hooks/use-theme-color'
import { WebsiteHeaderChildrenEntities } from './website-header-children-entities'

export interface WebsiteHeaderProps {
  entity: WebsiteHeaderInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const WebsiteHeader = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: WebsiteHeaderProps) => {
  const { headerAndFooter } = useThemeColor()
  const { backgroundImage } = useBackgroundImage({
    backgroundFileId: headerAndFooter?.headerBackgroundPicture.file?.id,
    mobileBackgroundFileId: headerAndFooter?.headerBackgroundPicture.file?.id,
  })

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed ?? false}
      isMoveDownAllowed={isMoveDownAllowed ?? false}
      isCopyAllowed={false}
      isMoveAllowed={false}
      isSaveAllowed={false}
      isRemoveAllowed={false}
      appearance={{ mobile: true, desktop: true }}
    >
      <CommonWebsiteHeader
        {...entity}
        backgroundImage={backgroundImage}
        background={headerAndFooter?.headerBackgroundPicture.background}
        backgroundColor={headerAndFooter?.headerBackgroundColor}
      >
        <WebsiteHeaderChildrenEntities childIds={entity.childIds} />
      </CommonWebsiteHeader>
    </BaseEntityNew>
  )
}
